module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/9-be79f3ddf696134da2d1fdefbd536243.png";